import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { mergeStyles } from '@uifabric/merge-styles';
import { getPalette } from 'owa-theme';

export default function getUserVoiceButtonColorStyle(colorScheme: ColorScheme) {
    const textColor = colorScheme ? colorScheme.calPrimary : getPalette().themePrimary;
    return mergeStyles({
        color: textColor,
        selectors: {
            ':hover': { color: textColor },
            ':active': { color: textColor },
        },
    });
}
